import qs from 'qs';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { ApiProfile } from '../../api/auth';
import styles from './styles.module.scss';
import { Button } from '../../kit';
import CreatePost from './CreatePost';
import { ApiPost, PostApi } from '../../models/Post';
import { ApiMeta } from '../../api';
import Pagination from '../../kit/collections/Table/Pagination';
import Post from './Post';

interface TimelineProps {
    auth: ApiProfile,
    profile?: ApiProfile
}

const Timeline: FC<TimelineProps> = ({ auth, profile }): JSX.Element => {
    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    const [ meta, setMeta ] = useState<ApiMeta>();
    const [ posts, setPosts ] = useState<ApiPost[]>([]);
    const scrolled = useRef<boolean>(false);

    const fetch = useCallback((page: number = 1) => {
        setIsLoading(true);
        PostApi.getList(page, profile?.id).then(({ data }) => {
            setIsLoading(false);
            if (page === 1) {
                setPosts(data.data);
            } else {
                setPosts((c) => [ ...c, ...data.data ]);
            }
            setMeta(data.meta);
        });
    }, [profile]);
    useEffect(() => {
        fetch(1);
        window.addEventListener('refresh-timeline', () => fetch(1), true);
        return () => window.removeEventListener('refresh-timeline', () => fetch(1), true);
    }, [fetch]);

    useEffect(() => {
        if (scrolled.current) return;
        const pidCheck = qs.parse(window.location.search.substring(1));
        if (pidCheck && pidCheck.pid) {
            setTimeout(() => {
                const elem = document.querySelector(`[data-id="${pidCheck.pid}"]`);
                if (elem) {
                    window.scrollTo({top: elem.getBoundingClientRect().top - 200, behavior: 'smooth'});
                }
            }, 200);
        }
        scrolled.current = true;
    }, [posts]);

    const focus = (): void => {
        dispatchEvent(new CustomEvent('focus-post'));
    }

    return (
        <div className={styles.timeline}>
            <CreatePost
                auth={auth}
                profileId={profile?.id}
                onPost={(post) => {
                    setPosts((p) => ([
                        post,
                        ...p,
                    ]));
                }}
            />
            <div className={styles.items}>
                {posts.length > 0 ? posts.map((post) => (
                    <Post
                        key={`post-${post.id}`}
                        auth={auth}
                        item={post}
                    />
                )) : (
                    <div className={styles.noItems}>
                        <i className="fa-regular fa-face-sad-sweat"></i>
                        <p>
                            {profile
                                ? `${profile.first_name} heeft nog geen berichten.`
                                : 'Nog geen berichten'
                            }
                        </p>
                        <Button
                            color="secondary"
                            label="Plaats een bericht"
                            onClick={() => focus()}
                        />
                    </div>
                )}
            </div>
            {meta && (
                <Pagination
                    meta={meta}
                    onChange={(newPage) => fetch(newPage)}
                    isLoading={isLoading}
                    infinite
                />
            )}
        </div>
    );
}

export default Timeline;
